( function($, waTheme) {

    var LazyLoading = ( function($) {

        LazyLoading = function(options) {
            var that = this;

            // VARS
            that.list_name = options["names"]["list"];
            that.items_name = options["names"]["items"];
            that.pagind_name = options["names"]["paging"];
            that.loading_name = ".js-products-paging-load";
            that.load_class = "is-loading";

            // DOM
            that.$wrapper = ( options["$wrapper"] || false );
            that.$list = that.$wrapper.find(that.list_name);
            that.$window = $(window);

            // DYNAMIC VARS
            that.$paging = that.$wrapper.find(that.pagind_name);
            that.$lazy_button = that.$wrapper.find(that.loading_name);
            that.scrollWatcher = null;
            that.onScrollLoading = that.$paging.hasClass("is-lazy-loading-scroll");

            // INIT
            that.init();
        };

        LazyLoading.prototype.init = function() {
            var that = this;

            if (that.onScrollLoading) {
                that.addWatcher();
            }

            that.bindEvents();
        };

        LazyLoading.prototype.bindEvents = function() {
            var that = this;

            that.$wrapper.on("click", ".js-products-paging-load", function () {
                event.preventDefault();
                that.loadNextPage();
            });

            that.addObserver();
        };

        LazyLoading.prototype.addObserver = function() {
            var that = this;

            let observerOptions = {
                // root: document.querySelector("#s-category-wrapper"),
                rootMargin: '0px',
                threshold: 0.5
            }

            const observer = new IntersectionObserver(observerCallback, observerOptions);

            function observerCallback(entries, observer) {
                entries.forEach(entry => {
                    if(entry.isIntersecting) {
                        console.log(entry.target);

                        let next_page_number = entry.target.getAttribute("data-page");

                        if ("pushState" in window.history) {

                            let is_changed = false;
                            let searchParams = new URLSearchParams(window.location.search);

                            if (next_page_number !== "1") {
                                searchParams.set("page", next_page_number);
                                is_changed = true;
                            } else if (searchParams.get("page") !== null) {
                                searchParams.delete("page");
                                is_changed = true;
                            }

                            if (is_changed === true) {
                                history.pushState({
                                    reload: true
                                }, "", location.origin + location.pathname + "?" + searchParams.toString());
                            }
                        }
                    }
                });
            }

            let target = '.s-product-wrapper';
            document.querySelectorAll(target).forEach((i) => {
                if (i) {
                    observer.observe(i);
                }
            });
        };

        LazyLoading.prototype.addWatcher = function() {
            var that = this;

            that.$window.on("scroll", scrollWatcher);
            function scrollWatcher() {
                var is_exist = $.contains(document, that.$wrapper[0]);
                if (is_exist) {
                    that.onScroll();
                } else {
                    that.$window.off("scroll", scrollWatcher);
                }
            }

            that.scrollWatcher = scrollWatcher;
        };

        LazyLoading.prototype.stopWatcher = function() {
            var that = this;

            if (that.scrollWatcher) {
                var scrollWatcher = that.scrollWatcher;
                that.$window.off("scroll", scrollWatcher);
            }
        };

        LazyLoading.prototype.onScroll = function() {
            var that = this,
                is_paging_exist = ( $.contains(document, that.$paging[0]) );

            if (is_paging_exist) {

                var $window = that.$window,
                    scroll_top = $window.scrollTop(),
                    display_height = $window.height(),
                    paging_top = that.$paging.offset().top;

                // If we see paging, stop watcher and run load
                if (scroll_top + display_height >= paging_top) {
                    that.stopWatcher();
                    that.loadNextPage();
                }

            } else {
                that.stopWatcher();
            }

        };

        LazyLoading.prototype.loadNextPage = function() {
            var that = this,
                next_page_url = getNextUrl(),
                next_page_number = that.$paging.find(".selected").next().text(),
                $paging = that.$paging;

            console.log(next_page_number);

            function getNextUrl() {
                var $nextPage = that.$paging.find(".selected").next(),
                    result = false;

                if ($nextPage.length) {
                    result = $nextPage.find("a").attr("href");
                }

                return result;
            }

            function showLoad() {
                $paging.addClass(that.load_class);
                if (that.onScrollLoading) {
                    var $loading = `<div class="b-products-spinner position-absolute start-50 translate-middle">
                                        <div class="spinner-border text-gray-500" role="status">
                                            <span class="visually-hidden">Loading...</span>
                                        </div>
                                    </div>`;

                    $paging.append($loading);
                } else {
                    let $loader  = $(".js-products-paging-load");
                    let loadingText = $loader.data("loading-text");

                    $loader.find(".spinner-border").removeClass("d-none");
                    $loader.find(".spinner-text").html(loadingText);
                }
            }

            if (next_page_url) {

                showLoad();

                $.get(next_page_url, function(response) {
                    var $category = $(response),
                        $newItems = $category.find(that.list_name + " " + that.items_name),
                        $newPaging = $category.find(that.pagind_name),
                        $newLazyButton = $category.find(that.loading_name);

                    $.each($newItems, function (index, item) {
                        item.setAttribute("data-page", next_page_number)
                    });

                    that.$list.append($newItems);

                    $paging.after($newPaging);
                    $paging.remove();

                    that.$paging = $newPaging;
                    // that.$lazy_button = $newLazyButton;

                    // Обновляем инстанс ленивой загрузки картинок
                    waTheme.init.site.ImageLazyLoad.update();

                    if (that.onScrollLoading) {
                        that.addWatcher();
                    }

                    that.addObserver();

                    // history change
                    if ("pushState" in window.history) {
                        let searchParams = new URLSearchParams(window.location.search);
                        searchParams.set("page", next_page_number);
                        history.pushState({
                            reload: true
                        }, "", location.origin + location.pathname + "?" + searchParams.toString());
                    }
                });
            }
        };

        return LazyLoading;

    })($);

    var ProductsInit = (function ($) {

        ProductsInit = function () {
            var that = this;

            // DOM
            that.$wrapper = $(".s-products-wrapper");

            // CONST

            // DYNAMIC VARS

            // INIT
            that.init();

            // EVENTS
        };

        ProductsInit.prototype.init = function () {
            var that = this;

            if (that.$wrapper.length) {
                that.$wrapper.each(function () {
                    new window.waTheme.init.shop.Products({
                        $wrapper: $(this),
                        use_lazy: !!$(this).find(".s-paging-wrapper").hasClass("is-lazy-loading"),
                    });

                    let $quantity = $(this).find(".s-quantity-section");
                    if ($quantity) {
                        $quantity.each(function () {
                            let product_id = $(this).parents(".s-product-wrapper").data("product-id");
                            new waTheme.init.shop.Quantity({
                                $wrapper: $(this),
                                denominator: window.waTheme["products"][`${product_id}`].denominator,
                                step: window.waTheme["products"][`${product_id}`].step,
                                min: window.waTheme["products"][`${product_id}`].min,
                                max: window.waTheme["products"][`${product_id}`].max,
                                locales: window.waTheme["products"][`${product_id}`].locales,
                                currency: window.waTheme["products"][`${product_id}`].currency,
                            });
                        });
                    }
                });
            }

        };

        return ProductsInit;

    })($);

    var Products = ( function($) {

        Products = function(options = {}) {
            var that = this;

            // DOM
            that.$wrapper = options["$wrapper"];
            that.$products = that.$wrapper.find(".s-product-wrapper:not(.s-product-wrapper-loaded)");

            // VARS
            that.use_lazy = ( options["use_lazy"] || false );
            that.use_slider = ( options['use_slider'] || false );

            console.log(that.use_lazy);

            // DYNAMIC VARS
            that.activeClass = "active";
            that.notification = window.waTheme.themesettings.settings["apps__shop_common_product_added_notification_type_buttons"]["value"];

            // INIT
            that.init();
        };

        Products.prototype.init = function() {
            var that = this;

            that.$products.addClass("s-product-wrapper-loaded");

            if (that.use_lazy) {
                console.log("initLazy");
                that.initLazy();
            }

            that.bindEvents();

        };

        Products.prototype.bindEvents = function() {
            var that = this,
                $wrapper = that.$wrapper;

            $wrapper.on("submit", "form.add-to-cart", function(event) {
                event.preventDefault();
                that.onSubmitProduct($(this));
            });

            $wrapper.on("click", ".js-preview-button", function (event) {
                event.preventDefault();
                that.onSubmitProduct($(this).parents(".s-product-wrapper").find("form.add-to-cart"), $(this).data("url"));
            });

            // Change image on hover
            $wrapper.on("mouseenter", ".b-products-images__nav", function () {

                //
                var $wrapper = $(this).parents(".b-products-images");

                //
                var step = parseInt($(this).data("step"));
                var currentStep = parseInt($wrapper.find(".b-products-images__nav.active").data("step"));

                if (step !== currentStep) {
                    that.changeImage($wrapper, step)
                }
            });

            $wrapper.on("mouseleave", ".b-products-images__nav", function () {
                if ($(this).data("return") === true) {
                    var $wrapper = $(this).parents(".b-products-images");
                    that.changeImage($wrapper, 1);
                }
            });

            // SKUS
            $wrapper.on("click", ".inline-select a", function (event) {
                event.preventDefault();
                that.onSelectClick( $(this) );
            });

            // autobadge and other plugin tooltip fix
            $wrapper.find('.inline-select a').on("mouseleave", function(event) {
                $("body").children(".tooltip").remove();
            });

            $wrapper.on("change", ".s-skus-wrapper input[type=radio]", function () {
                var $input = $(this),
                    is_active = ($input.attr("checked") === "checked");
                if (is_active) {
                    that.onSkusClick( $(this) );
                }
            });

            $wrapper.on("change", ".js-sku-feature", function (event) {
                that.onSkusChange( $(this) );
            });

            //
            $wrapper.on("mouseenter", ".s-product-wrapper--skus", function (event) {
                var rect = $(this)[0].getBoundingClientRect();
                var rect_info = $(this).find(".s-info-wrapper")[0].getBoundingClientRect();
                $(this).find(".s-info-wrapper").css("height", rect_info.height);
                $(this).css("height", rect.height);
                $(this).addClass("is-hovered");
            });

            $wrapper.on("mouseleave", ".s-product-wrapper--skus", function (event) {
                $(this).removeClass("is-hovered");
                $(this).css("height", "");
                $(this).find(".s-info-wrapper").css("height", "");
            });

            // MASS ADD
            $wrapper.on("click", ".js-add-checkbox", function (event) {
                // event.preventDefault();
                that.onSingleCheck( $(this) );
            });

            $wrapper.on("click", ".js-mass-add-checkbox", function (event) {
                // event.preventDefault();
                that.onMassCheck( $(this) );
            });

            $wrapper.on("click", ".js-mass-add-button", function (event) {
                // event.preventDefault();
                that.onMassAdd( $(this) );
            });
        };

        //

        Products.prototype.initLazy = function() {
            var that = this;

            new LazyLoading({
                $wrapper: that.$wrapper,
                names: {
                    list: ".s-products-list",
                    items: ".s-product-wrapper",
                    paging: ".s-paging-wrapper"
                }
            });
        };

        // MASS ADD
        Products.prototype.onSingleCheck = function($checkbox) {
            var that = this,
                $button = that.$wrapper.find(".js-mass-add-button"),
                $count = $button.find(".spinner-count"),
                count = parseFloat($count.html());

            count = $checkbox.attr("checked") === "checked" ? ++count : --count;
            $count.html(count);
        };

        Products.prototype.onMassCheck = function($item) {
            var that = this,
                $checkbox = that.$wrapper.find(".js-add-checkbox"),
                $button = that.$wrapper.find(".js-mass-add-button"),
                $count = $button.find(".spinner-count"),
                count = parseFloat($count.html());

            $checkbox.each(function () {
                if ($item.attr("checked")) {
                    if (!$(this).attr("disabled")) {
                        $(this).prop("checked", true);
                        ++count;
                    }
                } else {
                    $(this).prop("checked", false);
                    count = 0;
                }

            });

            $count.html(count);
        };

        Products.prototype.onMassAdd = function($button) {
            var that = this,
                $checkbox = that.$wrapper.find(".js-add-checkbox:checked"),
                count = $checkbox.length;

            $checkbox.each(function (index) {
                var $product = $(this).parents(".s-product-wrapper"),
                    $form = $product.find("form.add-to-cart"),
                    last = index === count - 1;

                that.onSubmitProduct($form, false, last, count);
            });

        };

        // ADD PRODUCT
        Products.prototype.onSubmitProduct = function($form, href, notify = true, products_count = 0) {
            var that = this,
                $product = $form.closest(".s-product-wrapper"),
                $button = $form.find(".js-add-button"),
                $checkout_button = $form.find(".js-checkout-link"),
                $mass_button = that.$wrapper.find(".js-mass-add-button"),
                $preview_button = $product.find(".js-preview-button"),
                product_name = $product.find(".s-product-header").text(),
                product_image = $product.find(".b-products-images__items .b-products-images__image:first-child img").attr("src"),
                product_data_image = $product.find(".b-products-images__items .b-products-images__image:first-child img").attr("data-src"),
                product_href = href ? href : $form.data("url"),
                add_class = "btn-theme",
                added_class = "btn-outline-theme",
                timer = 0,
                time = products_count > 1 ? 0 : 300;

            if (product_data_image !== undefined) {
                product_image = product_data_image;
            }

            let products_locale = window.waTheme.plurals(products_count - 1, [window.waTheme.locale.product[0].substring(2), window.waTheme.locale.product[1].substring(2), window.waTheme.locale.product[2].substring(2)]);

            let toastHTML =
                `<a class="b-products-toast d-flex" href="${window.waTheme.checkout_url}">
                    <div class="b-products-toast__image">
                       <img src="${product_image}">
                    </div>
                    <div class="ms-3">
                        <div class="fs-md fw-bold mb-1 text-dark">
                            ${window.waTheme.locale.product_added_to_cart}
                        </div>
                        <div class="fs-sm mb-1">
                            <span class="text-dark">${product_name}</span>
                            <span class="text-quaternary ${products_count > 1 ? "" : "d-none"}">
                                ${window.waTheme.locale.and_more} ${products_count - 1} ${products_locale}
                            </span>
                        </div>
                        <div class="link-theme fs-sm">
                            ${window.waTheme.locale.go_to_cart}
                        </div>
                    </div>
                </a>`;

            if (products_count === 0) {
                $button.attr("disabled", true);
                $preview_button.attr("disabled", true);
                // $button.find(".spinner-border").addClass("d-none");
            } else {
                that.notification = "toast"
                $mass_button.attr("disabled", true);
                $mass_button.find(".spinner-border").removeClass("d-none");
            }

            if (product_href) {

                $.post(product_href, function( html ) {

                    $button.attr("disabled", false);
                    $preview_button.attr("disabled", false);
                    // $button.find(".spinner-border").removeClass("d-none");

                    var dialog = new window.waTheme.init.site.Dialog({
                        html: html
                    });

                    var $dialog = dialog.$dialog;

                    $dialog.on("addedToCart", function(event, response) {
                        $button
                            .attr("disabled", true)
                            .removeClass(add_class)
                            .addClass(added_class);
                        $button.find(".spinner-text").html(window.waTheme.locale["added_to_cart"]);

                        //
                        if ($checkout_button.length) {
                            $button.addClass("is-hidden");
                            $checkout_button.removeClass("is-hidden");
                        }
                    });
                });

            } else {

                let $action = $form.attr('action');
                if (products_count === 0) {
                    $action = $action + '?items=1&html=1';
                }

                $.post($action, $form.serialize(), function(response) {
                    if (response.status === "ok") {

                        if (!waTheme.apps["shop"].cart) {
                            location.reload();
                            return false;
                        }

                        //
                        $button
                            .removeClass(add_class)
                            .addClass(added_class);
                        $button.find(".spinner-text").html(window.waTheme.locale["added_to_cart"]);

                        //
                        if ($checkout_button.length) {
                            $button.addClass("is-hidden");
                            $checkout_button.removeClass("is-hidden");
                        }

                        // Update Cart at Header
                        if (response["data"]) {
                            var count = response["data"]["count"],
                                text = response["data"]["total"];

                            if (text && count >= 0) {
                                waTheme.apps["shop"].cart.update(response["data"]);
                            }
                        }

                        clearTimeout(timer);
                        timer = setTimeout( function() {
                            var is_exist = $.contains(document, $button[0]);
                            if (is_exist) {
                                $button.attr("disabled", false);
                                $preview_button.attr("disabled", false);

                                if (that.notification === "toast" && notify !== false) {
                                    const toast = new window.waTheme.init.site.Toast({
                                        html: toastHTML
                                    });

                                    if (products_count !== 0) {
                                        $mass_button.attr("disabled", false);
                                        $mass_button.find(".spinner-border").addClass("d-none");
                                    }

                                } else if (that.notification === "modal" && notify !== false) {
                                    $.get(window.waTheme.cart_url + `?item_id=${response["data"]["item_id"]}&modal=1`, function (html) {
                                        const dialog = new window.waTheme.init.site.Dialog({
                                            html: html
                                        });

                                        var product_id = $(".b-product-added-modal .b-product-added-modal__item").data("product-id");
                                        new window.waTheme.init.shop.ProductsModal({
                                            $wrapper: $(".b-product-added-modal"),
                                        });
                                        new waTheme.init.shop.Quantity({
                                            $wrapper: $(".b-product-added-modal .s-quantity-section"),
                                            denominator: window.waTheme["products"][`${product_id}`].denominator,
                                            step: window.waTheme["products"][`${product_id}`].step,
                                            min: window.waTheme["products"][`${product_id}`].min,
                                            max: window.waTheme["products"][`${product_id}`].max,
                                            locales: window.waTheme["products"][`${product_id}`].locales,
                                            currency: window.waTheme["products"][`${product_id}`].currency,
                                        });
                                    });
                                }
                            }
                        }, time);

                    } else if (response.status === "fail") {

                        let toastHTML =
                            `<div class="b-products-toast d-flex align-items-center">
                                ${response.errors}
                            </div>`;

                        const toast = new window.waTheme.init.site.Toast({
                            html: toastHTML
                        });

                    }

                }, "json").always( function() {
                    // $button.find(".spinner-border").addClass("d-none");
                    $preview_button.attr("disabled", false);
                });
            }
        };

        Products.prototype.changeImage = function ($wrapper, step, image_id = 0) {
            var that = this;

            if (image_id !== 0) {
                let $image = $wrapper.find(`#s-image-${image_id}`);
                step = $image.parent(".b-products-images__image").data("step");
            }

            if (step === undefined) return;

            var $images = $wrapper.find(".b-products-images__image");
            var $navs = $wrapper.find(".b-products-images__nav");
            var $dots = $wrapper.find(".b-products-images__dot");

            //
            $images.removeClass(that.activeClass);
            $navs.removeClass(that.activeClass);
            $dots.removeClass(that.activeClass);

            //
            $wrapper.find(`.b-products-images__image[data-step="${step}"]`).addClass(that.activeClass);
            $wrapper.find(`.b-products-images__nav[data-step="${step}"]`).addClass(that.activeClass);
            $wrapper.find(`.b-products-images__dot[data-step="${step}"]`).addClass(that.activeClass);

        };

        Products.prototype.onSkusClick = function( $link ) {
            var that = this,
                sku_id = $link.val(),
                name = $link.next("label").text(),
                price = $link.data("price"),
                compare_price = $link.data("compare-price"),
                image_id = $link.data('image-id');

            // change name in dropdown
            $link.parents(".s-skus-wrapper").find(".s-skus-wrapper__dropdown-name").html(name);
            $link.parents(".s-skus-wrapper").find(".dropdown-item").removeClass("is-active");
            $link.parent(".dropdown-item").addClass("is-active");


            var $product = $link.closest(".s-product-wrapper");
            var product_data = waTheme.products_features[$product.attr("data-product-id")];

            var sku = (product_data.skus[sku_id] ? product_data.skus[sku_id] : null);
            if (!sku) { alert("SKU ERROR"); return false; }

            waTheme.addCurrency(product_data.currency_data);

            renderSKU($product, sku.sku);

            that.toggleAvailable($product, !$link.data('disabled'), sku, sku_id);

            that.updatePrice($product, product_data, sku, sku.id);

            // change image by sku_id
            that.changeImage($product, 0, sku.image_id);
        };

        Products.prototype.onSelectClick = function( $link ) {
            var $select = $link.closest('.inline-select'),
                data = $link.data("value"),
                active_class = "active";

            //
            $select.find("a." + active_class).removeClass(active_class);
            //
            $link.addClass(active_class);
            //
            $select.find(".js-sku-feature")
                .val(data)
                .change();
        };

        Products.prototype.updatePrice = function($product, product_data, sku, sku_id) {
            var that = this,
                hidden_class = "is-hidden";

            var $price = $product.find(".js-product-price");
            var $compare = $product.find(".js-compare-price");
            var $base_price = $product.find(".js-product-base-price");
            var $stock_base_ratio = $product.find(".js-stock-base-ratio");

            var $zero_price = $product.find(".js-product-price-zero");

            var $stock_total_ratio = $product.find(".js-stock-total-ratio");
            var $stock_total_quantity = $product.find(".js-stock-total-quantity");

            // console.log($product);

            // Настройки дробных
            var fractional_config = product_data["fractional_config"];
            // Массив с единицами измерения
            var units = product_data["units"];

            var price = sku["price"],
                compare_price = sku["compare_price"],
                stock_base_ratio = sku.stock_base_ratio,
                stock_unit_name,
                base_unit_name;

            console.warn(price);

            price = (parseFloat(price) >= 0 ? parseFloat(price) : 0);
            compare_price = (parseFloat(compare_price) > 0 ? parseFloat(compare_price) : null);
            stock_base_ratio = (parseFloat(stock_base_ratio) > 0 ? parseFloat(stock_base_ratio) : null);

            if (fractional_config["stock_units_enabled"]) {
                if (product_data.stock_unit_id && product_data.units[product_data.stock_unit_id]) {
                    stock_unit_name = units[product_data.stock_unit_id].name_short;
                }
            }

            if (fractional_config["base_units_enabled"]) {
                if (product_data.base_unit_id && (product_data.stock_unit_id !== product_data.base_unit_id) && units[product_data.base_unit_id] && stock_base_ratio) {
                    base_unit_name = units[product_data.base_unit_id].name_short;
                }
            }

            //
            var services_price = 0,
                price_sum = (price + services_price),
                compare_sum = (compare_price + services_price);

            // Render Price
            var price_string = waTheme.formatPrice(price_sum, { currency: product_data.currency, unit: stock_unit_name });
            $price.html(price_string);

            // Render Compare
            if (compare_price) {
                var compare_price_string = waTheme.formatPrice(compare_sum, { currency: product_data.currency, unit: stock_unit_name });
                $compare
                    .html(compare_price_string)
                    .removeClass(hidden_class);

            } else {
                $compare.addClass(hidden_class);
            }

            // Base Price
            if ($base_price.length) {
                if (base_unit_name) {
                    var base_sub = (price_sum/stock_base_ratio),
                        base_price_string = waTheme.formatPrice(base_sub, { currency: product_data.currency, unit: base_unit_name });

                    $base_price
                        .html(base_price_string)
                        .show();
                } else {
                    $base_price.hide();
                }
            }

            // Stock Base Ratio
            if ($stock_base_ratio.length) {
                if (stock_base_ratio) {
                    $stock_base_ratio
                        .html(waTheme.localizeNumber(formatNumber(sku.stock_base_ratio), { currency: product_data.currency }))
                        .show();
                } else {
                    $stock_base_ratio
                        .hide()
                        .html("");
                }
            }

            // Badges
            if (compare_price > 0) {
                $product.find(".badge--compare").removeClass("is-hidden");
                $product.find(".badge--benefit").removeClass("is-hidden");

                let savings_percent = Math.round((compare_price - price) / (compare_price / 100));
                $product.find(".badge--compare").html(`- ${savings_percent} %`);

                let savings_price = waTheme.formatPrice(compare_price - price, { currency: product_data.currency });
                $product.find(".badge--benefit").html(`${window.waTheme.locale.benefit} ${savings_price}`);

            } else {
                $product.find(".badge--compare").addClass("is-hidden");
                $product.find(".badge--benefit").addClass("is-hidden");
            }

            // Zero Price
            if (price === 0) {
                $price.addClass(hidden_class);
                $compare.addClass(hidden_class);
                $base_price.hide();
                $zero_price.removeClass(hidden_class);
            } else {
                $price.removeClass(hidden_class);
                $zero_price.addClass(hidden_class);
            }

            //
            function getServicePrice() {
                // DOM
                var $checkedServices = that.$services.find("input:checked");

                // DYNAMIC VARS
                var services_price = 0;

                $checkedServices.each( function () {
                    var $service = $(this),
                        service_value = $service.val(),
                        service_price = 0;

                    var $serviceVariants = $form.find(".service-" + service_value + " .service-variants");

                    if ($serviceVariants.length) {
                        service_price = parseFloat( $serviceVariants.find(":selected").data("price") );
                    } else {
                        service_price = parseFloat( $service.data("price") );
                    }

                    services_price += service_price;
                });

                return services_price;
            }

            function formatNumber(number) {
                var result = number;
                if (typeof number !== "string") { return result; }

                var float_num = parseFloat(number);
                if (float_num < 1) {
                    var split_num = number.split(".");
                    if (split_num.length === 2) {
                        var decimal_part = split_num[1].replace(/^0+/, '');
                        number = roundNumber(float_num, split_num[1].length - decimal_part.length + 3).toFixed(8);
                    }
                } else {
                    number = roundNumber(float_num, 3).toFixed(8);
                }

                var parts = number.split(".");
                if (parts.length === 2) {
                    var tail = parts[1],
                        result2 = [],
                        result3 = [parts[0]];

                    if (tail.length) {
                        for (var i = 0; i < tail.length; i++) {
                            var letter = tail[tail.length - (i+1)];
                            if (letter !== "0" || result2.length) {
                                result2.push(letter);
                            }
                        }
                        if (result2.length) {
                            result3.push(result2.reverse().join(""));
                        }
                    }

                    result = result3.join(".");
                }

                return result;
            }

            function roundNumber(num, scale) {
                if(!String(num).includes("e")) {
                    return +(Math.round(num + "e+" + scale)  + "e-" + scale);
                } else {
                    var parts = String(num).split("e"),
                        sig = "";

                    if(+parts[1] + scale > 0) {
                        sig = "+";
                    }
                    return +(Math.round(+parts[0] + "e" + sig + (+parts[1] + scale)) + "e-" + scale);
                }
            }
        };

        Products.prototype.toggleAvailable = function($product, available, sku, sku_id) {
            var that = this,
                $button = $product.find("button[type=submit]"),
                cart_items = window.waTheme.cart_items,
                added_class = "is-added",
                is_added = false;

            if (sku_id) {
                for (const cartItemsKey in cart_items) {
                    if (cart_items[cartItemsKey]["sku_id"] === sku_id && is_added === false) {
                        is_added = true;
                        $button.addClass(added_class);
                        $button.removeClass("btn-theme").addClass("btn-outline-theme");
                        $button.find(".spinner-text").html(window.waTheme.locale["added_to_cart"]);
                    }
                }
            }

            if (is_added === false) {
                $button.removeClass(added_class);
                $button.removeClass("btn-outline-theme").addClass("btn-theme");
                $button.find(".spinner-text").html(window.waTheme.locale["add_to_cart"]);
            }

            // toggle button
            $button.attr("disabled", !available);

            // toggle stocks
            $product.find(".s-stocks-wrapper > div").each( function() {
                var $stock = $(this),
                    is_target = $stock.hasClass("sku-" + sku_id + "-stock");

                if (available && is_target) {
                    $stock.show();
                } else {
                    $stock.hide();
                }
            });

            $product.find(".s-stocks-wrapper > .sku-not-available").css("display", (available ? "none" : ""));

            // toggle mass add
            if (available) {
                $product.find(".js-add-checkbox").prop("disabled", false)
            } else {
                $product.find(".js-add-checkbox").prop("disabled", true)
                $product.find(".js-add-checkbox").prop("checked", false)
            }


            // quantity
            // if (available) {
            //     that.$quantity_section.removeClass("d-none");
            // } else {
            //     that.$quantity_section.addClass("d-none");
            // }
        };

        Products.prototype.onSkusChange = function($wrapper) {
            var that = this;

            // DOM
            var $product = $wrapper.closest(".s-product-wrapper");
            var product_data = waTheme.products_features[$product.attr("data-product-id")];

            waTheme.addCurrency(product_data.currency_data);

            var key = getKey(),
                sku_features = product_data.features[key];

            var sku_id = null;

            if (sku_features) {
                var sku_name = false;
                try { sku_name = product_data.skus[sku_features.id].sku; } catch(e) {}

                sku_id = sku_id = sku_features.id;
                var sku = product_data.skus[sku_id];

                renderSKU($product, sku_name);
                //
                // that.updateSkuServices(sku.id);
                //
                // that.changeImage(sku.image_id);
                //
                if (sku_features.available) {
                    that.toggleAvailable($product,true, sku, sku.id);
                } else {
                    that.toggleAvailable($product,false, sku, sku.id);
                }

                //
                sku["compare_price"] = ( sku["compare_price"] ) ? sku["compare_price"] : 0 ;
                //
                that.updatePrice($product, product_data, sku, sku.id);

                // change image by sku_id
                that.changeImage($product, 0, sku.image_id);
            } else {
                //
                that.toggleAvailable($product,false, sku_features);
            }

            function getKey() {
                var result = "";

                $product.find(".js-sku-feature").each( function () {
                    var $input = $(this);

                    result += $input.data("feature-id") + ':' + $input.val() + ';';
                });

                return result;
            }
        };

        return Products;

        function renderSKU($product, sku) {
            var $sku = $product.find(".js-products-sku"),
                $wrapper = $sku.closest(".s-sku-wrapper");

            if (sku) {
                $sku.text(sku);
                $wrapper.show();
            } else {
                $sku.text("");
                $wrapper.hide();
            }
        }

    })($);

    waTheme.init.shop.ProductsInit = ProductsInit;
    waTheme.init.shop.Products = Products;

    //
    new window.waTheme.init.shop.ProductsInit();

})(jQuery, window.waTheme);